import Radio from 'components/ui-components/Radio';
import RadioContainer from 'components/ui-components/RadioContainer';
import { branchTermSingularCapitalised } from 'utils/terminology';

import type {
  InvoiceAddress,
  AccountDetails,
} from 'lib/types/deliveryAddressChooseAddress';

interface ComponentProps {
  signed_in: boolean;
  addressMode: string;
  setAddressMode: (id: string) => void;
  setAddressModeRemoveAddresses: (ADDRESS_MODE: string) => void;
  invoiceAddress: InvoiceAddress;
  account: AccountDetails;
}

interface RadioOption {
  id: string;
  label: string;
  name?: string;
}

const ChooseDeliveryAddress = ({
  signed_in: signedIn,
  addressMode,
  setAddressMode,
  setAddressModeRemoveAddresses,
  invoiceAddress,
  account: { number: accountNumber },
}: ComponentProps) => {
  const addressLines = [
    invoiceAddress?.name ? <strong>{invoiceAddress.name}</strong> : null,
    invoiceAddress?.line_1,
    invoiceAddress?.line_2,
    invoiceAddress?.line_3,
    invoiceAddress?.line_4,
    invoiceAddress?.line_5,
    invoiceAddress?.postcode,
  ].filter(Boolean);

  const radioOptions: RadioOption[] = signedIn
    ? [
        { id: 'INVOICE_ADDRESS', label: 'Deliver to Invoice Address' },
        { id: 'ADDRESS_BOOK', label: 'Choose from Address Book' },
        { id: 'NEW_ADDRESS', label: 'Enter a New Address' },
      ]
    : [
        {
          id: 'GUEST_NEW_ADDRESS',
          label: 'Enter a New Address',
          name: 'delivery',
        },
      ];

  return (
    <div className={`checkout-sub-panel ${!signedIn ? 'guest-choose' : ''}`}>
      <div className="checkout-address">
        <div className="checkout-address__column">
          <div className="checkout-address__radios-container">
            {signedIn && <h2>Delivery Address</h2>}

            <RadioContainer groupName="delivery">
              <>
                {radioOptions.map(({ id, name, label }) => (
                  <Radio
                    key={id}
                    id={id}
                    name={name}
                    label={label}
                    checked={addressMode === id}
                    onChange={() => setAddressMode(id)}
                  />
                ))}
              </>

              <Radio
                id="BRANCH_DELIVERY"
                label={`Deliver to a ${branchTermSingularCapitalised}`}
                checked={addressMode === 'BRANCH_DELIVERY'}
                onChange={() =>
                  setAddressModeRemoveAddresses('BRANCH_DELIVERY')
                }
              />
            </RadioContainer>
          </div>
        </div>

        {signedIn && (
          <div className="checkout-address__column">
            <div className="checkout-address__address-container">
              <div className="checkout-address__address">
                <h2>Invoice Address</h2>
                <p>
                  {addressLines.map((line, index) => (
                    <span key={accountNumber.toString() + line}>
                      {line}
                      {index < addressLines.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </div>

              <div className="account-number">
                <h2>Account Number</h2>
                <p>{accountNumber}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChooseDeliveryAddress;
